import React, {
  useState,
  RefObject,
  ReactNode,
  useEffect,
  forwardRef,
  useImperativeHandle,
  ForwardRefRenderFunction,
} from 'react';

import {
  SelectChangeEvent,
  Select as MUISelect,
  SelectProps as MUISelectProps,
} from '@mui/material';

type Props = MUISelectProps & {
  value?: any;
  handleOnChange?: (value?: string) => void;
  children: ReactNode;
};

export interface SelectRef {
  value: any;
  node: HTMLSelectElement | null;
}

const Select: ForwardRefRenderFunction<SelectRef, Props> = (
  { value, handleOnChange, children, ...rest },
  ref
) => {
  const [selectValue, setSelectValue] = useState<any>(value || '');
  const internalRef = React.useRef<HTMLSelectElement>(null);

  const handleChange = (event: SelectChangeEvent<string>) => {
    const newValue = event.target.value;
    setSelectValue(newValue);
    if (handleOnChange) {
      handleOnChange(newValue);
    }
  };

  useImperativeHandle(ref, () => ({
    value: selectValue,
    node: internalRef.current,
  }));

  useEffect(() => {
    if (value !== selectValue) {
      setSelectValue(value);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <MUISelect
      value={selectValue}
      onChange={handleChange}
      inputRef={internalRef}
      {...rest}
    >
      {children}
    </MUISelect>
  );
};

export default forwardRef<SelectRef, Props>(Select);
